<template>
  <DialogRoot v-model:open="wrapped.isOpen">
    <div
      class="before:contents-[''] relative mx-auto shrink-0 overflow-hidden rounded-full p-2 before:pointer-events-none before:absolute before:left-1/2 before:top-1/2 before:aspect-square before:w-[200%] before:origin-top-left before:-translate-x-1/2 before:-translate-y-1/2 before:bg-[linear-gradient(in_srgb-linear_to_right,#00ff00,#fb0094,#00ff00,#fb0094)] before:[animation:gradient_2s_linear_infinite]"
    >
      <DialogTrigger as-child>
        <Button
          variant="primary-flat"
          class="w-fit items-center text-3xl font-bold outline-none"
        >
          <img
            aria-hidden="true"
            src="/images/emojis/confetti.png"
            class="mr-1 inline-block h-6 w-6"
          />
          Your 2024 Wrapped!
        </Button>
      </DialogTrigger>
    </div>
    <DialogPortal>
      <DialogOverlay
        class="fixed inset-0 z-50 grid place-items-center overflow-y-auto bg-black/90 data-[state=open]:animate-overlay-show"
      >
        <DialogContent
          class="relative h-fit w-full max-w-[414px] px-px py-6 outline-none"
          :aria-describedby="undefined"
          @pointer-down-outside="
            (event) => {
              const originalEvent = event.detail.originalEvent;
              const target = originalEvent.target as HTMLElement;
              if (
                originalEvent.offsetX > target.clientWidth ||
                originalEvent.offsetY > target.clientHeight
              ) {
                event.preventDefault();
              }
            }
          "
        >
          <VisuallyHidden>
            <DialogTitle>Your 2024 Wrapped</DialogTitle>
          </VisuallyHidden>

          <Suspense>
            <WrappedModalContentWrapper @progress="progress = $event" />
            <template #fallback>
              <div
                class="fixed left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-4"
              >
                <p
                  class="text-shadow animate-pulse text-center font-Kontesa text-4xl font-bold text-white"
                >
                  LOADING <br />
                  Wrapped 2024 <br />
                </p>
                <ProgressRoot v-model="progress" as-child>
                  <Box
                    border="md"
                    shadow="lg"
                    rounded="full"
                    class="relative h-4 w-[256px] overflow-hidden bg-white"
                  >
                    <ProgressIndicator
                      :style="`transform: translateX(-${100 - progress * 100}%)`"
                      class="h-full w-full rounded-full bg-success transition-transform duration-150 ease-out"
                    />
                  </Box>
                </ProgressRoot>
              </div>
            </template>
          </Suspense>
        </DialogContent>
      </DialogOverlay>
    </DialogPortal>
  </DialogRoot>
</template>

<script setup lang="ts">
const wrapped = useWrappedUp();
const progress = ref(0);
</script>

<style>
@keyframes gradient {
  from {
    transform: rotate(0deg) translate(-50%, -50%);
  }
  to {
    transform: rotate(360deg) translate(-50%, -50%);
  }
}
</style>
